import {Button, ButtonProps} from '@graphcommerce/next-ui'
import {Trans} from '@lingui/react'
import {
  useAddProductsToCartAction,
  UseAddProductsToCartActionProps
} from '@graphcommerce/magento-product/components/AddProductsToCart/useAddProductsToCartAction'
import {useRouter} from 'next/router'


export function ProductPageLoginToBuyButton() {
  const router = useRouter()
  const handleClick = async () => {
    await router.push('/account/signin')
  }

  return (
    <Button type='button' color='primary' variant='pill' size='large' fullWidth onClick={handleClick}>
      <Trans id='Log in to buy' />
    </Button>
  )
}
